import type { FC } from 'react';

type CodeProps = {
	children?: React.ReactNode;
	block?: boolean;
	className?: string;
};

export const Code: FC<CodeProps> = ({ children, block, className }) => {
	const baseStyles =
		'font-mono bg-gray-50 border border-dashed border-gray-300 rounded-sm dark:bg-gray-800 text-gray-700 dark:text-gray-100';
	const blockStyles = block ? 'block overflow-x-auto p-3' : 'px-2 py-1';
	return (
		<pre>
			<code className={`${baseStyles} ${blockStyles} ${className ?? ''}`}>{children}</code>
		</pre>
	);
};
